/**
 * Labstep
 *
 * @module prosemirror/components/NodeView/SmartTable
 * @desc Renders an SmartTable node
 */

import { EntityViewSmartTable } from 'labstep-web/components/EntityView/SmartTable';
import type { Experiment } from 'labstep-web/models/experiment.model';
import { Read } from 'labstep-web/prosemirror/components/NodeView/Read';
import { useReactNodeView } from 'labstep-web/prosemirror/components/ReactNodeView';
import React from 'react';
import type { ISmartTableNodeProps } from './types';

export const agGridProseMirrorClass = 'ag-grid-prosemirror';

export class SmartTableNode extends React.Component<ISmartTableNodeProps> {
  public shouldComponentUpdate(): boolean {
    return false;
  }

  public render(): JSX.Element {
    const { id, entity } = this.props;
    return (
      <Read entityName={entity.entityName} id={entity.id}>
        {({ entity }): JSX.Element => {
          return (
            <div
              contentEditable={false}
              onClick={(e) => e.stopPropagation()}
            >
              <EntityViewSmartTable
                entityViewId={id}
                experimentOrProtocol={entity as Experiment}
                initialExpandedState={true}
              />
            </div>
          );
        }}
      </Read>
    );
  }
}

export const SmartTableNodeView = ({ id, entity }: any) => {
  const context = useReactNodeView();
  const { id: idAttr } = (context.node as any).attrs;

  return <SmartTableNode id={idAttr} entity={entity} />;
};
